export default __webpack_public_path__ + "static/media/NoChatPreview.adc71754.svg";